<template>
  <div class="action-sort-container" :class="device.isMobile ? 'action-sort-container-mobile' : ''">
    <div class="reset" @click.stop="reset"></div>
    <div class="action-content">
      <!-- <draggable
        
        :sort="false"
        :disabled="true"
        :group="{
          name: content.key,
          pull: false,
          put: false
        }"
        v-model="resultData"
      >
        <transition-group class="action-List">
          <div
            class="action-item"
            v-for="(item, index) in resultData"
            :key="index"
            @drop="dropHandle($event, item, index)"
            @dragstart="dragstartHandle($event, item, 'result')"
            :class="!!item.cover ? 'item-has-sort' : ''"
          >
            <div v-if="item.cover" class="action-cover">
              <img :src="item.cover" :alt="item.title" :title="item.title">
            </div>
            <div class="action-cover action-item-default" v-else></div>
            <div class="isTrue" v-if="item.isTrue">{{ item.title }}</div>
          </div>
        </transition-group>
      </draggable> -->
      <div class="action-list">
        <div
          class="action-item"
          v-for="(item, index) in resultData"
          :key="index"
        >
          <draggable
            class="action-drop"
            :sort="false"
            :disabled="false"
            :group="{
              name: content.key,
              pull: false,
              put: dropChecked(item)
            }"
            @add="dropHandle($event, item, index)"
            v-model="item.newArr"
          >
            <div class="" v-for="(it, idx) in item.newArr" :key="idx">
              <img :src="it.cover" :alt="it.title" :title="it.title">
            </div>
          </draggable>
          <div v-if="item.newArr.length === 0" class="action-cover action-item-default"></div>
          <div class="isTrue" v-if="item.isTrue">{{ item.title }}</div>
          <div class="isTrue" v-else></div>
        </div>
      </div>
    </div>
    <div v-if="!isComplete" class="action-handle-info">请将下方的图片拖拽至上方对应的框中，完成排序</div>
    <draggable
      v-if="!isComplete"
      class="action-handle"
      :sort="false"
      :group="{
        name: content.key,
        pull: true,
        put: false
      }"
      v-model="handleData"
      @start="dragstartHandle"
    >
      <template v-for="item in handleData">
        <div
          :key="item.key"
          v-if="!item.hideInHandle"
          class="action-handle-item"
        >
          <img :src="item.cover" :alt="item.title" :title="item.title">
        </div>
      </template>
    </draggable>
    <div class="anwser" v-if="isComplete">
      <div class="anwser-title">参考答案:</div>
      <div class="anwser-text">{{ content.answerInfo }}</div>
    </div>
  </div>
</template>
<script>
/*
交互动作组件 -- 排一排
*/
import draggable from "vuedraggable";
import { getActionData, setActionData } from "@/utils/storage";
export default {
  name: "sortAction",
  components: {
    draggable
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      resultData: [],
      handleData: [],
      isComplete: false,
      historyData: null,
      dragKey: '',
      dragIndex: 0,
    }
  },
  mounted() {
    this.historyData = (JSON.parse(getActionData()) || {})
    let historyData = this.historyData[this.content.key]
    this.handleData = this.content.sortData;
    this.resultData = this.content.answerData.map((answer, index) => {
      let returnData = this.content.sortData.find(sort => {
        return sort.answerKey == answer
      });
      
      returnData = JSON.parse(JSON.stringify(returnData))
      returnData.newArr = []
      if(historyData && historyData[index]) {
        returnData.isTrue = 1
        returnData.newArr.push(returnData)
      }
      return returnData
    })
    
    this.handleData = this.content.sortData.filter(item => {
      return !(historyData && historyData.includes(item.key))
    });
    this.isCompleteFn();
  },
  methods: {
    // 开始拖拽记录拖拽的元素
    dragstartHandle(e) {
      let handleData = this.handleData[e.oldIndex];
      console.log(e.oldIndex, handleData)
      this.dragKey = handleData.answerKey;
      this.dragIndex = e.oldIndex;
      console.log(this.dragKey, this.dragIndex)
    },
    // 是否可以拖入的判断
    dropChecked(item) {
      if(item.newArr.length > 0) return false;
      return true
    },
    // 拖拽直接显示正确答案，不正确的拖拽不进去
    dropHandle(e, item, index) {
      let handleIndex = this.dragIndex
      let resultIndex = index
      
      if(this.resultData[resultIndex].newArr[0].answerKey !== this.resultData[resultIndex].answerKey) {
        let changeData = this.resultData[resultIndex].newArr[0]
        this.$set(this.resultData[resultIndex], 'newArr', [])
        this.handleData.splice(handleIndex, 0, changeData)
        this.$forceUpdate()
        return false
      }

      this.$set(this.resultData[resultIndex], 'isTrue', 1)
      this.isCompleteFn();
      
      let historyData = {}
      historyData[this.content.key] = this.resultData.map(result => (result.newArr[0] || {}).key);
      this.historyData = Object.assign({}, this.historyData, historyData)
      setActionData(JSON.stringify(this.historyData));
    },
    dragstartHandle1(e, item, dragType) {
      item.dragType = dragType;
      e.dataTransfer.setData("content", JSON.stringify(item));
    },
    // 拖拽直接显示正确答案，不正确的拖拽不进去
    dropHandle1(e, item, index) {
      let data = e.dataTransfer.getData("content");
      data = JSON.parse(data)
      if(data.actionKey !== this.content.key) {
        return false
      }
      if(data.dragType === 'handle') {
        console.log(data, this.content.answerData[index])
        if(data.answerKey === this.content.answerData[index]) {
          if(this.resultData[index].key) {
            let handleShowIndex = this.handleData.findIndex(i => i.key === item.key)
            this.$set(this.handleData[handleShowIndex], 'hideInHandle', false)
          }
          // 从数据栏拖拽到操作栏，隐藏已经加入过的数据栏的数据
          this.$set(this.resultData, index, data)
          this.$set(this.resultData[index], 'mark', 'right')
          this.$set(this.resultData[index], 'isTrue', 1)
          let handleIndex = this.handleData.findIndex(i => i.key === data.key)
          this.$set(this.handleData[handleIndex], 'hideInHandle', true)
          // 判断是否全部完成
          this.isCompleteFn();
          
          let historyData = {}
          historyData[this.content.key] = this.resultData.map(item => item.answerKey);
          this.historyData = Object.assign({}, this.historyData, historyData)
          setActionData(JSON.stringify(this.historyData));
        }
      }
    },
    // 判断是否全部完成
    isCompleteFn() {
      let isComplete = true;
      this.resultData.forEach(i => {
        if(i.isTrue !== 1) {
          isComplete = false
          return
        }
      })
      this.isComplete = isComplete;
    },
    // 重置整个内容
    reset() {
      this.handleData = this.content.sortData.map(item => {
        item.hideInHandle = false
        return item
      });
      this.resultData = this.content.answerData.map(answer => {
        let returnData = this.content.sortData.find(sort => {
          return sort.answerKey == answer
        });
        returnData = JSON.parse(JSON.stringify(returnData))
        returnData.newArr = []
        return returnData
      })
      this.isComplete = false;

      delete this.historyData[this.content.key]
      setActionData(JSON.stringify(this.historyData));
    },
  },
}
</script>


<style lang="scss" scoped>
.action-sort-container{

  .reset{
    width: 34rem;
    height: 34rem;
    background: url(~@/assets/images/books/bookExample/reset.png) center center no-repeat;
    background-size: contain;
    position: absolute;
    top: 10rem;
    right: 14rem;
    cursor: pointer;
  }

  .action-content{
    margin: 0 auto;

    .action-list{
      display: flex;
      justify-content: space-between;
      padding: 20rem 0;
      border-bottom: 1rem solid #E3E3E3;

      .action-item{
        width: 130rem;
        border-radius: 6rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        position: relative;
        margin-right: 57rem;

        .action-drop{
          width: 130rem;
          height: 130rem;
          border-radius: 6rem;
          position: relative;

          img{
            display: block;
            width: 130rem;
            height: 130rem;
          }
          
          &:after{
            content: '';
            width: 30rem;
            height: 20rem;
            background: url("~@/assets/images/books/bookExample/arrow-gray-icon.png") center center no-repeat;
            background-size: contain;
            position: absolute;
            top: 50%;
            right: -44rem;
            margin-top: -10rem;
          }

        }

        .action-item-default{
          width: 130rem;
          height: 130rem;
          background: #E3E3E3;
          border-radius: 6rem;
        }

        .action-cover{
          position: absolute;
          top: 0;
          left: 0;

          &:after{
            content: '';
            width: 30rem;
            height: 20rem;
            background: url("~@/assets/images/books/bookExample/arrow-gray-icon.png") center center no-repeat;
            background-size: contain;
            position: absolute;
            top: 50%;
            right: -44rem;
            margin-top: -10rem;
          }

          img{
            display: block;
            max-width: 130rem;
            max-height: 130rem;
          }
        }
  
        .isTrue{
          font-size: 16rem;
          color: #999;
          line-height: 26rem;
          height: 26rem;
          padding: 10rem 0;
        }
        
        &:last-child{
          margin-right: 0;
          
          .action-drop{
            &:after{
              display: none;
            }
          }

          .action-cover{
            &:after{
              display: none;
            }
          }
        }
      }
  
      .item-has-sort{
        border: 2rem solid transparent;
      }
    }

  }

  .action-handle-info{
    font-size: 16rem;
    color: #333;
    margin-top: 20rem;
  }

  .action-handle{
    display: flex;
    min-height: 80rem;
    margin-top: 20rem;

    .action-handle-item{
      margin-right: 12rem;
      img{
        display: block;
        max-width: 80rem;
        max-height: 80rem;
      }
    }
  }

  .anwser{
    font-size: 16rem;
    color: #333;
    line-height: 24rem;
    display: flex;
    margin-top: 20rem;

    .anwser-title{
      white-space: nowrap;
      margin-right: 20rem;
    }
  }
}

.action-sort-container-mobile{
  .reset{
    width: 44rem;
    height: 44rem;
  }
  .action-content{
    .action-list{
      padding: 70rem 0 30rem;
      .action-item{
        width: 150rem;
        margin-right: 32rem;
        .action-drop{
          width: 150rem;
          height: 150rem;
          img{
            width: 150rem;
            height: 150rem;
          }
          &:after{
            content: '';
            width: 28rem;
            height: 16rem;
            right: -31rem;
            margin-top: -8rem;
          }
        }
        .action-item-default{
          width: 150rem;
          height: 150rem;
        }
        .action-cover{
          &:after{
            content: '';
            width: 28rem;
            height: 16rem;
            right: -31rem;
            margin-top: -8rem;
          }
          img{
            display: block;
            max-width: 150rem;
            max-height: 150rem;
          }
        }
        .isTrue{
          font-size: 20rem;
        }
      }
    }
  }
  .action-handle{
    min-height: 120rem;
    .action-handle-info{
      font-size: 20rem;
    }
    .action-handle-item{
      img{
        max-width: 120rem;
        max-height: 120rem;
      }
    }
  }
  
  .anwser{
    font-size: 24rem;
    line-height: 36rem;
  }
}
</style>